import { combineReducers } from 'redux';
import catalog from './modules/main-data/reducers'
import login from '../../../login/redux/login/reducers'
import admin from '../../../admin/src/redux/reducers'
import ui from './modules/ui/reducers'
import catalogs from './modules/catalogs/reducers'
import categories from './modules/categorias/reducers'
import marcas from './modules/marcas/reducers'

const reducers = combineReducers({
  ui,
  catalog,
  admin,
  login,
  catalogs,
  categories,
  marcas
});

export default reducers;